// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"UiDropdownByHover_dropdown__2qZu4","dropdownButton":"UiDropdownByHover_dropdownButton__3Bs3G","dropdownContent":"UiDropdownByHover_dropdownContent__3uIbb"};